module.exports = __webpack_public_path__ + "c8654f11f445b42548bd93f5d9e67d36.mp4";